import React from 'react';
import Header from '../../components/header/index';
import Footer from '../../components/footer/index';
import MyMarkdown from '../../components/markdown/index';
import BackTop from '../../components/backtop/index'
import http from '../../http/http';
import global from '../../http/common';
import './index.css';

class Trends extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      infoData: {
        title: "",
        sendTime: ""
      }
    }
  }
  componentDidMount () {
    let id = this.props.match.params.id;
    http.get("/public/api/news/detail", {
      newsId: id
    }, response => {
      if (response && response.result) {
        let result = response.result;
        console.log(result);
        this.setState({
          infoData: result
        });
        this.replaceMarkdownText(result.content);
      }
    });
  }
  replaceMarkdownText (text) {
    let newText = text;

    let spaceReg = /\S+[\n|\n\r]+<img /g;
    let spaceMatchArr = newText.match(spaceReg);
    if (spaceMatchArr && spaceMatchArr.length) {
      for (let i = 0; i < spaceMatchArr.length; i++) {
        let content = spaceMatchArr[i];
        let newContent = content.replace(/\n|\n\r/g, "<br/>");
        newText = newText.replace(content, newContent);
      }
    }
    //兼容#
    let comReg = /#+[^#/s]/g;
    let comMatchArr = newText.match(comReg);
    if (comMatchArr && comMatchArr.length) {
      for (let i = 0; i < comMatchArr.length; i++) {
        let content = comMatchArr[i];
        let firstContent = content.substring(0, content.length - 1);
        let lastContent = content.substring(content.length - 1, content.length);
        newText = newText.replace(new RegExp(content, "g"), firstContent + " " + lastContent);
      }
    }
    //匹配图片
    let imageReg = /\([^\)]*\.(png|jpg|gif|svg|mp4|jpeg)\)/g;
    let imageMatchArr = newText.match(imageReg);
    if (imageMatchArr && imageMatchArr.length) {
      for (let i = 0; i < imageMatchArr.length; i++) {
        let content = imageMatchArr[i];
        let src = content.substring(content.indexOf("(") + 1, content.length - 1);
        let url = http.hostUrl + http.contextName + "/images/news/" + this.props.match.params.id + "/" + src;
        newText = newText.replace(new RegExp(content, "g"), url);
      }
    }
    //匹配图片 src=这种形式的
    text = global.escapeDecode(text);
    let srcReg = /src=\"\S*\.(png|jpg|gif|svg|mp4)\"/g;
    let srcMatchArr = newText.match(srcReg);
    if (srcMatchArr && srcMatchArr.length) {
      for (let i = 0; i < srcMatchArr.length; i++) {
        let content = srcMatchArr[i];
        let src = content.substring(5, content.length - 1);
        let url = http.hostUrl + http.contextName + "/resource/news/" + this.props.match.params.id + "/" + src;
        newText = newText.replace(new RegExp(content, "g"), "src=\"" + url + "\"");
      }
    }
    let imgWidthReg = /<img[^>]*>/g;
    let imgWidthMatchArr = newText.match(imgWidthReg);
    if (imgWidthMatchArr && imgWidthMatchArr.length) {
      for (let i = 0; i < imgWidthMatchArr.length; i++) {
        let content = imgWidthMatchArr[i];
        if (content.indexOf("width") != -1) {
          let firstContent = content.substring(0, content.length - 1);
          let lastContent = content.substring(content.length - 1, content.length);
          let widthReg = /width=\"\S*\"/g;
          let widthArr = content.match(widthReg);
          let width = "100%";
          if (widthArr && widthArr) {
            width = widthArr[0];
          }
          width = width.substring(width.indexOf("\"") + 1, width.length - 1);
          newText = newText.replace(new RegExp(content, "g"), firstContent + " style='width:" + width + ";' " + lastContent);
        }
      }
    }
    console.log(newText);
    this.changeMarkdownText(newText);
  }
  changeMarkdownText (text) {
    if (this.refs.myMarkdowRef) {
      this.refs.myMarkdowRef.changeMarkdownText(text);
    }
  }
  render () {
    return (
      <div className='trendinfo_index_wrap'>
        <Header index="3"></Header>
        <div className="trends_info_content box-padding-horizontal box-padding-vertical">
          <div className="logo">NEWS</div>
          <div className="title">{this.state.infoData.title}</div>
          <div className="time">{this.state.infoData.sendTime}</div>
          <div className="markdown">
            <MyMarkdown ref="myMarkdowRef"></MyMarkdown>
          </div>
          {/* <BackTop></BackTop> */}
        </div>
        <Footer></Footer>
      </div>
    );
  }
}
export default Trends;